<script>
    export default {
        props: {
            title: String,
            value: Array,
        }
    }
</script>


<template>
    <div class="log_container">
        <div class="log_header_container">
            <label>{{ title }}</label>
        </div>
        <hr>
        <div class="log_value_container">
            <label
                v-for="(valueObject, valueIndex) in value" :key="valueIndex"
                class="mt_5"
            >{{ valueObject }}</label>
        </div>
    </div>
</template>